<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Amanda LaBrooy lives in Darwin in the tropical north of Australia with her husband, two grown sons and Turbo the dog. To satisfy her desire for adventure and to escape the corporate world, she enjoys creating stories with strong characters.</p><br/>
<p style="text-indent:00em;">In her spare time, she can be found curled up with a good book or at the gym throwing weights around, trying to look like a pro.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?c17db6de